import React from 'react';
import GrowlyyLogo from '../common/GrowlyyLogo';

const Hero: React.FC = () => {
  return (
    <section id="accueil" className="pt-24 pb-12 md:pt-32 md:pb-24 bg-gradient-growlyy">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-10 md:mb-0">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              L'agence de prospection qui fonctionne à la performance
            </h1>
            <p className="text-xl text-gray-100 mb-8 max-w-lg">
              Nous générons des rendez-vous qualifiés pour votre entreprise grâce à notre expertise en prospection multicanal. Concentrez-vous sur vos ventes, nous nous occupons de remplir votre agenda.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <a href="https://zcal.co/adriengeen/15min" target="_blank" rel="noopener noreferrer" className="btn-primary btn-large btn-pulse">
                Commencez maintenant
              </a>
              <a href="https://zcal.co/adriengeen/15min" target="_blank" rel="noopener noreferrer" className="btn-secondary text-white hover:bg-white btn-large">
                Parlons-en
              </a>
            </div>
            <div className="mt-8 text-gray-100">
              <p>✓ Configuration en moins de 15 minutes</p>
              <p>✓ Annulez à tout moment</p>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-growlyy-secondary rounded-lg transform rotate-3 scale-105 opacity-20"></div>
              <div className="relative bg-white p-6 rounded-lg shadow-2xl">
                <div className="mb-4 flex justify-center">
                  <GrowlyyLogo size="small" />
                </div>
                <img 
                  src="/images/dashboardscreen.png" 
                  alt="Dashboard Growlyy" 
                  className="rounded w-full"
                />
                <div className="mt-4 text-center text-growlyy-primary">
                  <p className="font-semibold">Votre pipeline commercial toujours plein</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 